import { Modal, SubmitButton } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React from "react";

type DefaultModalProps = Record<string, any>;

export type ConfirmationModalProps<
    ConfirmationValue = boolean,
    ModalProps extends DefaultModalProps = DefaultModalProps,
> = Omit<ModalProps, "open" | "onClose" | "onContinue"> & {
    isOpen: boolean;
    onClose: () => void;
    onContinue: (value?: ConfirmationValue) => void;
};

export const PostCheckInWarningModal = ({ isOpen, onClose, onContinue }: ConfirmationModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent onClose={onClose} onContinue={onContinue} />
    </Modal>
);

export const ModalContent = ({ onClose, onContinue }: Omit<ConfirmationModalProps, "open">) => (
    <>
        <Modal.Header>Warning: Guest already checked-in</Modal.Header>
        <Modal.Body className="flex justify-center">
            You are about to modify a reservation for which guests have already checked-in. Are you sure you want to
            continue?
        </Modal.Body>
        <Modal.Footer className="flex justify-end">
            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            <SubmitButton onClick={onContinue}>Continue</SubmitButton>
        </Modal.Footer>
    </>
);
